import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Injectable()
export class FieldValidatorService {
    constructor() { }

    isInteger(control: FormControl) {
        if ((parseFloat(control.value) == parseInt(control.value)) && !isNaN(control.value)) {
            return null;
        } else {
            return { notNumeric: true }
        }
    }

    isPositiveInteger(control: FormControl) {
        let intValue = parseInt(control.value);
        if (!intValue)
            return null;
        if ((parseFloat(control.value) == intValue) && !isNaN(control.value) && intValue > 0 && intValue < 2000000001) {
            return null;
        } else {
            return { notNumeric: true }
        }
    }

    isPositiveNumber(control: FormControl) {
        let floatValue = parseFloat(control.value);
        if (!floatValue)
            return null;
        if (floatValue > 0) {
            return null;
        } else {
            return { notPositive: true }
        }
    }

    isValidDecimal(control: FormControl) {
        let floatValue = parseFloat(control.value);
        let places = 0;
        if (control.value && control.value.toString().indexOf('.') !== -1)
            places = control.value.toString().split('.')[1].length;
        if (!floatValue)
            return null;
        if (floatValue > 0 && floatValue < 2000000001 && places <= 4) {
            return null;
        } else {
            return { notDecimal: true }
        }

    }

    isHundredIntegerRange(control: FormControl) {
        let intValue = parseInt(control.value);
        if (!intValue)
            return null;
        if ((parseFloat(control.value) == intValue) && !isNaN(control.value) && intValue > -1 && intValue < 101) {
            return null;
        } else {
            return { notHundredIntegerRange: true }
        }
    }

    isGreatherOrEqualThan(firstField: string, secondField: string) {
        return (group: FormGroup): { [key: string]: any } => {
            let firstControl = group.controls[firstField];
            let secondControl = group.controls[secondField];

            if (!firstControl || !firstControl.value || !secondControl || !secondControl.value)
                return null;

            if (parseFloat(firstControl.value) < parseFloat(secondControl.value)) {
                return {
                    notGreatherOrEqual: true
                };
            }

            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/field-validator-service.ts